import { Dispatch } from "redux";
import { v4 as uuid } from "uuid";
import { Alert } from "../components/modules/alert.model";
import { AlertTypes, SET_ALERT, REMOVE_ALERT } from "@leap4/frontend";

export const setAlert =
  (msg: string, type: AlertTypes, timeout = 5000) =>
    (dispatch: Dispatch) => {
      const id = uuid();
      dispatch({
        type: SET_ALERT,
        payload: new Alert(id, type, msg),
      });

      setTimeout(() => dispatch({ type: REMOVE_ALERT, payload: id }), timeout);
    };
